export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form fields No."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Required ID missing"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You have successfully logged in, continue operations at the ATM"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continue ATM transactions"])}
}